declare var require;

export class AnimationContents {
    public static FULLSCREEN_JSON = require('../animate/FullScreen.json');
    public static ORIENTATION_SCREEN_JSON = require('../animate/OrientationScreen.json');
    public static GAME_SCREEN_JSON = require('../animate/GameScreen.json');
    public static GARAGE_SCREEN_JSON = require('../animate/NewGarageScreen.json');
    public static LEADERBOARD_SCREEN_JSON = require('../animate/LeaderboardScreen.json');
    public static LEVEL_UI_JSON = require('../animate/LEVEL_UI.json');
    public static LEVEL_SELECTION_JSON = require('../animate/LevelSelectionScreen.json');
    public static END_SCREEN_JSON = require('../animate/EndScreen.json');
    public static LOADER_SCREEN_JSON = require('../animate/LoaderScreen.json');
    public static NAME_SCREEN_JSON = require('../animate/NameScreen.json');
    public static SETTINGS_JSON = require('../animate/SettingsScreen.json');
    public static FTUE_JSON = require('../animate/ftue.json');
    public static ERROR_MODAL_JSON = require('../animate/ErrorModal.json');
}
